<template>
  <div class="">
    <FormKit :validation-messages="{}" v-if="!pasoFechaLimite" type="form" :schema="formSchema" @submit="handleSubmit"
      v-model="valores">
      <FormKitSchema type="form" :schema="formSchema" @submit="handleSubmit" />

      <template #submit>
        <div>
          <div class="flex flex-col md:flex-row items-center justify-between text-sm text-gray-400 gap-3"
            v-if="esAdmin">
            <!-- <div>
            Podés seguir editando tu historia hasta el miércoles a las 23:59 Hs.
          </div>
          <button
            type="submit"
            class="bg-blue-500 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded w-full md:w-auto"
          >
            Guardar
          </button> -->
          </div>
        </div>
      </template>
    </FormKit>
    <!-- Si ya paso, mostrar un preview, con el titulo, el tema y el cuerpo -->
    <div v-else>
      <div class="border-t border-gray-200 pt-4">
        <div class="border-white border text-xs py-1 rounded-full inline mb-2">
          {{ valores.tema }}
        </div>
        <h3 class="text-xl font-semibold text-gray-700 leading-snug">
          {{ valores.titulo }}
        </h3>
        <p class="text-base text-gray-600 leading-normal" v-for="parrafo in valores.cuento.split('\n')">
          {{ parrafo }}
        </p>

        <!-- Explicar, que la edición está cerrada, pero que lo van a poder seguir editando en otra instancia -->
        <div class="text-sm text-gray-500 mt-4 border-t border-gray-200 pt-4">
          La edición de tu historia está cerrada, pero podrás seguir editándola
          en otra instancia.
        </div>
        <div class="text-sm font-semibold text-gray-800">
          ¡Nos vemos el domingo a las 15 Hs!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from "vue";
import { notify } from "notiwind";
import axios from "axios";
import { miUsuario } from "@/services/usuarios";
import { defineProps } from "vue";

const SERVER = "https://staging-strapi.orsai.org";

export default defineComponent({
  name: "CuentoForm",
  setup(props) {
    const formSchema = ref([]);
    const valores = ref({ cuento: "" });
    const audio = ref({
      url: "Walter",
    });
    const cuento = ref("");
    const cuentoRaw = ref({});
    const usuario = ref({});

    const taller = ref("");
    function maxWords(node, max = 50) {
      let s = node._value;
      if (s === undefined) return 0;
      if (s === null) return 0;
      s = s.replace(/(^\s*)|(\s*$)/gi, "");//exclude  start and end white-space
      s = s.replace(/[ ]{2,}/gi, " ");//2 or more space to 1
      s = s.replace(/\n /, "\n"); // exclude newline with a start spacing
      return s.split(' ').filter(function (str) { return str != ""; }).length;
    }

    const parrafos = (texto) => {
      return texto.split("\n").join("<br>");
    };

    // Es 14 de ENERO a las 00:01 hora de Argentina, tener en cuenta visitantes con distinto timezone
    // const fechaLimite = new Date("2025-01-14T02:59:00Z");
    const pasoFechaLimite = false; //computed(() => new Date() > fechaLimite);

    // esAdmin cuando en el query viene admin
    const esAdmin = computed(() => {
      return true;
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.has("admin");
    })

    const fetchCuentoUsuario = async () => {
      try {
        // Obtener los cuentos del usuario
        const resCuentos = await axios.get(
          `${SERVER}/api/cuentos?filters[idUsuario]=${usuario.value.id}`
        );

        console.log("Cuentos del usuario:", resCuentos.data.data);

        const cuentoTaller = resCuentos.data.data.find(
          (cuento) => !cuento.taller || cuento.taller === ""
        );
        const documentIdCuento = cuentoTaller.documentId;

        const response = await fetch(
          `${SERVER}/api/cuentos/${documentIdCuento}?populate=*`
        );

        const tmp = await response.json();
        const dataCuento = tmp.data;

        console.log("Cuento:", dataCuento);

        if (tmp.data && tmp.data.audio)
          audio.value = `${SERVER}${tmp.data.audio.url}`;

        if (dataCuento) {
          console.log("Cuento:", dataCuento);
          valores.value = dataCuento;
          cuento.value = dataCuento.cuento;
          cuentoRaw.value = dataCuento;
        }
      } catch (error) {
        console.error("Error al obtener el cuento:", error);
      }
    };

    const fetchSchemaFromStrapi = async () => {
      try {
        const response = await axios.get(
          `${SERVER}/api/content-type-builder/content-types`
        );

        const vocesSchema = response.data.data.find(
          (model) => model.uid === "api::cuento.cuento"
        );

        // Verificar si tiene cuento con titulo
        const tieneCuentoConTitulo =
          cuentoRaw.value && cuentoRaw.value.titulo && cuentoRaw.value.tema;
        console.log(
          "Tiene cuento con titulo:",
          cuentoRaw.value,
          tieneCuentoConTitulo
        );

        if (vocesSchema) {
          formSchema.value = Object.entries(vocesSchema.schema.attributes)
            // Filtrar los privados
            .filter(([key, value]) => !value.private)
            // Ocultar titulo y tema
            .filter(([key, value]) => {
              // Ocultar, audio, y resumen
              return !["taller", "tema"].includes(key);

              // Si el usuario no es 1, 3 o 1384, ocultar el campo audio
              // if (![1, 3, 1384].includes(usuario.value.id) && key === "audio") {
              //   console.log("Ocultar audio");
              //   return false;
              // }

              return true;
            })
            .sort((a, b) => {
              const order = ["key", "titulo", "tema", "resumen", "cuento"];
              return order.indexOf(a[0]) - order.indexOf(b[0]);
            })
            .map(([key, value]) => {
              switch (value.type) {
                case "string":
                  return {
                    $formkit: "text",
                    name: key,
                    label: formatLabel(key),
                    validation: value.required ? "required" : "",
                    disabled: ["titulo"].includes(key) && tieneCuentoConTitulo,
                  };
                case "text":
                case "richtext":
                  // Si es cuento maxWords es 30, sino 300
                  const maxWordsRule = key === "cuento" ? "300" : "30";

                  return {
                    $formkit: "wctextarea",
                    name: key,
                    label: formatLabel(key),
                    props: {
                      minHeight: key === "cuento" ? "20rem" : "",
                      maxWordsRule: maxWordsRule,
                    },
                    validationRules: { maxWords },
                    validation: value.required
                      ? "required|maxWords:" + maxWordsRule
                      : "maxWords:" + maxWordsRule,
                    validationMessages: {
                      maxWords:
                        "Solo puedes escribir hasta " +
                        maxWordsRule +
                        " palabras.",
                    },
                    // disabled: tieneCuentoConTitulo && ["titulo", "tema"].includes(key),
                  };
                case "enumeration":
                  //   El primer valor es null y es el default
                  value.enum.unshift({
                    value: null,
                    label: "-- Seleccioná una temática -- ",
                  });

                  return {
                    $formkit: "select",
                    name: key,
                    label: formatLabel(key),
                    options: value.enum,
                    validation: value.required ? "required" : "",
                    // disabled: tieneCuentoConTitulo && ["titulo", "resumen", "tema"].includes(key),
                  };
                case "media":
                  // Si se llama audio, solo permitir mp3
                  if (key === "audio") {
                    // Agregar un helper text
                    return {
                      $formkit: "audio_orsai",
                      name: key,
                      label: formatLabel(key),
                      accept: ".mp3",
                      validation: value.required ? "required" : "",
                      help: "Podés subir un archivo de audio en formato mp3, ogg o wav.",
                    };
                  }

                  return {
                    $formkit: "file",
                    name: key,
                    label: formatLabel(key),
                  };
                default:
                  return null;
              }
            })

            .filter(Boolean);
        }
      } catch (error) {
        console.error("Error al obtener el esquema:", error);
      }
    };

    const formatLabel = (key) => {
      // Mapear los labels segun el nombre del campo
      const labels = {
        key: "Título de tu historia",
        titulo: "Título de tu historia",
        tema: "¿A qué temática pertenece?",
        cuento: "Tu historia, en 300 palabras",
        resumen: "Resumen",
      };

      return (
        labels[key] ||
        key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, " $1")
      );
    };

    const handleSubmit = async (data) => {
      try {
        console.log("handleSubmit", data);
        const originalData = { ...data };
        // Quitar de data los campos que no se deben enviar
        data = Object.fromEntries(
          Object.entries(data).filter(
            ([key]) => !["cantidadVotos", "sumaVotos"].includes(key)
          )
        );

        // Quitar el audio del data, para no enviarlo
        if (data.audio) {
          delete data.audio;
        }

        if (!valores.value.id) {
          console.log("Crear cuento", data);
          const res = await axios.post("https://staging-strapi.orsai.org/api/cuentos", {
            data: {
              ...data,
              idUsuario: usuario.value.id,
              email: usuario.value.email,
              taller: taller.value,
            },
          });

          valores.value = res.data.data;
        } else {
          console.log("Actualizar cuento", data);
          const datos = Object.fromEntries(
            Object.entries(data).filter(
              ([key]) =>
                !["documentId", "id", "createdAt", "updatedAt"].includes(key)
            )
          );

          const cuentoNuevo = await axios.put(
            `https://staging-strapi.orsai.org/api/cuentos/${valores.value.documentId}`,
            {
              data: {
                ...datos,
                idUsuario: usuario.value.id,
                email: usuario.value.email,
                taller: taller.value,
              },
            }
          );
          valores.value = cuentoNuevo.data.data;
          console.log("Cuento actualizado", cuentoNuevo.data.data);
        }

        // En cualquier de los dos casos
        // Si tiene una imagen, hay que subirla en el endpoint /api/upload
        if (originalData.audio && originalData.audio[0]) {


          // Si no hay archivo, no hacer nada
          if (!originalData.audio[0].file) {
            return;
          }

          const formData = new FormData();
          formData.append("files", originalData.audio[0].file);
          formData.append("ref", "api::cuento.cuento");
          formData.append("refId", valores.value.id);
          formData.append("field", "audio");

          const audio = await axios.post(`${SERVER}/api/upload`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
        }

        notify(
          {
            group: "foo",
            title: "¡Listo!",
            type: "success",
            text: "Tu historia se guardó correctamente.",
          },
          20000
        );
      } catch (error) {
        console.error("Error al enviar el formulario:", error);
        notify(
          {
            group: "foo",
            title: "Error",
            type: "error",
            text: "Hubo un error al guardar tu historia.",
          },
          2000
        );
      }
    };

    // Si el formulario se edita, prevenir la recarga: onbeforeunload
    // window.onbeforeunload = function () {
    //   return "¿Estás seguro de que quieres salir? Tu historia no se guardará.";
    // };
    onMounted(async () => {
      usuario.value = await miUsuario();
      await fetchCuentoUsuario();
      await fetchSchemaFromStrapi();
    });

    return {
      formSchema,
      audio,
      valores,
      cuento,
      handleSubmit,
      pasoFechaLimite,
      parrafos,
      esAdmin
    };
  },
});
</script>
<style>
/* Los estilos de los labels en caps */
/* .formkit-label {
  text-transform: uppercase;
  font-size: 1rem;
  padding-bottom: 0.35rem;
  padding-top: 0.7rem;
} */
</style>
>
